import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';

import logo from './assets/iteq-logo.png';

const styles = theme => ({
  root: {
    minHeight: '80vh',
    flex: '0 0 auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 
      theme.palette.type === 'light' ? theme.palette.primary.light : theme.palette.primary.dark,
    color: theme.palette.primary.contrastText,
  },
  content: {
    paddingBottom: theme.spacing.unit * 8,
    paddingTop: theme.spacing.unit * 8,
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing.unit * 12,
    },
    textAlign: 'center',
  },
  text: {
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 4,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  headline: {
    maxWidth: 500,
    textAlign: 'center',
  },
  buttons: {
    display: 'inline-block',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    height: 55,
    textDecoration: 'none'
  },
  logo: {
    maxHeight: 200,
    backgroundColor: 'white',
    paddingLeft: '3em',
    paddingRight: '3em',
    borderRadius: 10,
  },
  super: {
    verticalAlign: 'super',
    fontSize: '0.25em'
  },
});

export function PageHome({ classes }) {
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <img
          src={logo}
          alt="ITEQ Logo"
          className={classes.logo}
        />
        <div className={classes.text}>
          <Typography variant="display2" component="h1" color="inherit" gutterBottom>
            ITEQ Stackup Pro
            <span className={classes.super}>TM</span>
          </Typography>
          <Typography
            variant="headline"
            component="h2"
            color="inherit"
            className={classes.headline}
          >
            Introducing the industry&apos;s first 3D web-based printed circuit board
            stackup design tool
          </Typography>
          <div className={classes.buttons}>
            <Link to="/app" style={{ textDecoration: 'none'}}>
              <Button className={classes.button} variant="raised">
                Launch
                <br />
                Stackup Pro
              </Button>
            </Link>
            <Button
              target="_blank"
              href="http://iteq.com.tw"
              className={classes.button}
              variant="raised"
            >
              Iteq Home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

PageHome.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    content: PropTypes.string,
    text: PropTypes.string,
    headline: PropTypes.string,
    buttons: PropTypes.string,
    button: PropTypes.string,
    logo: PropTypes.string,
    super: PropTypes.string
  }).isRequired,
};

export default compose(withStyles(styles))(PageHome);


// WEBPACK FOOTER //
// ./src/components/HomePage/Iteq/Hero.jsx